module.exports = __webpack_public_path__ + "img/ccb.bd82ff88.jpg";